import type { MouseEvent } from "react";
import { Icon } from "@/components/Icon";
import "./SetupMenu.css";

interface SetupMenuProps {
  active: boolean;
  onNavigate: (path: string) => void;
  variant: "sidebar" | "topbar";
}

/**
 * The gear — Setup moved off the five-tile bar entirely (ADR 0009 §1: "Setup moves to a
 * gear so the bar never grows to six"). Sits in the sidebar footer above Log out on
 * laptop, and in the topbar on phone — outside `<nav aria-label="Primary">` either way,
 * so it never counts toward the five-tile budget `shell.spec.ts` measures.
 */
export function SetupMenu({ active, onNavigate, variant }: SetupMenuProps) {
  function handleClick(event: MouseEvent<HTMLAnchorElement>): void {
    if (
      event.defaultPrevented
      || event.button !== 0
      || event.metaKey
      || event.ctrlKey
      || event.shiftKey
      || event.altKey
    ) {
      return;
    }
    event.preventDefault();
    onNavigate("/setup");
  }

  return (
    <a
      href="/setup"
      className={`setup-menu setup-menu--${variant}${active ? " setup-menu--active" : ""}`}
      aria-current={active ? "page" : undefined}
      onClick={handleClick}
    >
      <Icon name="gear" size={variant === "sidebar" ? 18 : 20} />
      <span>Setup</span>
    </a>
  );
}
